/* DENTYS ADD-TO-CART TOAST
   Defines <cart-notification> with the same small interface Dawn's assets/product-form.js
   expects (getSectionsToRender, setActiveElement, renderContents), so the product page
   needs no change. Also adds ajax add-to-cart to the Studentams product list, whose
   buttons are plain {% form 'product' %} forms that otherwise POST to /cart/add and
   land the visitor on the cart page.
   Markup and strings: snippets/dentys-cart-toast.liquid. Styles: dentys-cart-toast.css. */
(function () {
  if (customElements.get('cart-notification')) return;

  var HIDE_AFTER = 5000; // ms the toast stays up
  var HIDE_AFTER_HOVER = 2500; // ms after the pointer/focus leaves it

  class DentysCartToast extends HTMLElement {
    constructor() {
      super();
      this.card = this.querySelector('.dcn__card');
      this.titleEl = this.querySelector('.dcn__title');
      this.itemEl = this.querySelector('.dcn__item');
      this.thumbEl = this.querySelector('.dcn__thumb');
      this.nameEl = this.querySelector('.dcn__name');
      this.linkEl = this.querySelector('.dcn__link');
      this.liveEl = this.querySelector('.dcn__sr');
      this.timer = null;
      this.hideTimer = null;

      this.querySelector('.dcn__close').addEventListener('click', this.close.bind(this));
      this.card.addEventListener('mouseenter', this.pause.bind(this));
      this.card.addEventListener('focusin', this.pause.bind(this));
      this.card.addEventListener('mouseleave', this.resume.bind(this));
      this.card.addEventListener('focusout', this.resume.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !this.card.hidden) this.close();
      }.bind(this));
    }

    /* ---- interface used by assets/product-form.js ---- */

    getSectionsToRender() {
      // Reuses the theme's existing section: it renders the localised "View cart (N)".
      return [{ id: 'cart-notification-button' }];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    renderContents(item) {
      var label = this.dataset.view;
      var html = item && item.sections && item.sections['cart-notification-button'];
      if (html) {
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        var text = node && node.textContent.replace(/\s+/g, ' ').trim();
        if (text) label = text;
      }

      var name = item && item.product_title ? item.product_title : '';
      if (item && item.variant_title && item.variant_title !== 'Default Title') {
        name += ' — ' + item.variant_title;
      }

      this.show({
        kind: 'success',
        title: this.dataset.added,
        name: name,
        image: item && item.featured_image && item.featured_image.url,
        linkText: label,
      });
      this.refreshBadge();
    }

    /* ---- display ---- */

    show(opts) {
      clearTimeout(this.timer);
      clearTimeout(this.hideTimer);

      var isError = opts.kind === 'error';
      this.card.classList.toggle('dcn__card--error', isError);

      this.titleEl.textContent = opts.title || '';

      if (opts.name) {
        this.nameEl.textContent = opts.name;
        if (opts.image) {
          try {
            var u = new URL(opts.image, window.location.origin);
            if (u.protocol === 'https:' || u.protocol === 'http:') u.searchParams.set('width', '120'); // 48px @2x+, small file
            this.thumbEl.src = u.toString();
          } catch (e) {
            this.thumbEl.src = opts.image;
          }
          this.thumbEl.hidden = false;
        } else {
          this.thumbEl.removeAttribute('src');
          this.thumbEl.hidden = true;
        }
        this.itemEl.hidden = false;
      } else {
        this.itemEl.hidden = true;
      }

      if (opts.linkText && !isError) {
        this.linkEl.textContent = opts.linkText;
        this.linkEl.hidden = false;
      } else {
        this.linkEl.hidden = true;
      }

      this.positionBelowHeader();

      // restart the enter transition even if a previous toast is still showing
      this.card.classList.remove('is-visible');
      this.card.hidden = false;
      void this.card.offsetWidth;
      this.card.classList.add('is-visible');

      // announce to screen readers (the visible card itself is not a live region)
      this.liveEl.textContent = '';
      var spoken = (opts.title || '') + (opts.name ? ': ' + opts.name : '');
      setTimeout(function () { this.liveEl.textContent = spoken; }.bind(this), 60);

      this.timer = setTimeout(this.close.bind(this), HIDE_AFTER);
    }

    close() {
      clearTimeout(this.timer);
      this.card.classList.remove('is-visible');
      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(function () { this.card.hidden = true; }.bind(this), 220);
    }

    pause() {
      clearTimeout(this.timer);
    }

    resume() {
      if (this.card.hidden) return;
      clearTimeout(this.timer);
      this.timer = setTimeout(this.close.bind(this), HIDE_AFTER_HOVER);
    }

    // The header is not sticky, so: if it is on screen, sit just under it (never cover the
    // account / cart icons); if the visitor has scrolled past it, sit at the top of the viewport.
    positionBelowHeader() {
      var top = 12;
      var header = document.querySelector('.dh');
      if (header) {
        var bottom = header.getBoundingClientRect().bottom;
        if (bottom > 0) top = Math.ceil(bottom) + 8;
      }
      this.style.setProperty('--dcn-top', top + 'px');
    }

    // The header cart badge (.dh__count) is rendered by the server, so it would go stale
    // after an ajax add. Bring it in line with the real cart.
    refreshBadge() {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var cartUrl = window.routes && window.routes.cart_url;
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.dh__ico').forEach(function (a) {
            if (cartUrl && a.getAttribute('href') !== cartUrl) return;
            var badge = a.querySelector('.dh__count');
            if (cart.item_count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'dh__count';
                a.appendChild(badge);
              }
              badge.textContent = cart.item_count;
            } else if (badge) {
              badge.remove();
            }
          });
        })
        .catch(function () {});
    }

    showError(message) {
      this.show({ kind: 'error', title: message || '' });
    }
  }

  customElements.define('cart-notification', DentysCartToast);

  /* ---- Studentams product list: plain <form class="dentys-g__form"> buttons ---- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('dentys-g__form')) return;

    var toast = document.querySelector('cart-notification');
    if (!toast || typeof toast.renderContents !== 'function' || !window.fetch || !window.routes) return; // native submit

    evt.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return;
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
    }

    var body = new FormData(form);
    body.append('sections', toast.getSectionsToRender().map(function (s) { return s.id; }));
    body.append('sections_url', window.location.pathname);

    var added = false;
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        added = true;
        if (data.status) {
          toast.showError(data.description || data.message);
        } else {
          toast.renderContents(data);
        }
      })
      .catch(function () {
        // Network or parse failure BEFORE we knew the outcome: fall back to the normal
        // form post so the add is never lost. Never after a confirmed add (would duplicate).
        if (!added) form.submit();
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('is-loading');
        }
      });
  });
})();
